import apiFarms from '../config/api_farms';
// import axios from 'axios';
import getHeaders from './getHeaders';

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
// });

// Buscar parâmetros do mapa da fazenda
export const getFarmMapParameters = async (groupId, farmId, signal = null) => {
  try {
    return apiFarms.get(
      `/bovexo/${groupId}/farms/${farmId}/maps/parameters`,
      getHeaders(false, signal)
    );
  } catch (error) {
    throw error;
  }
};

// Buscar parâmetro do mapa da fazenda por ID
export const getFarmMapParameterById = async (groupId, farmId, parameterId, signal = null) => {
  try {
    return apiFarms.get(
      `/bovexo/${groupId}/farms/${farmId}/maps/parameters/${parameterId}`,
      getHeaders(false, signal)
    );
  } catch (error) {
    throw error;
  }
};

// Salvar novo parâmetro do mapa da fazenda
export const createFarmMapParameter = async (groupId, farmId, parameterData) => {
  try {
    return apiFarms.post(
      `/bovexo/${groupId}/farms/${farmId}/maps/parameters`,
      parameterData,
      getHeaders(false, null)
    );
  } catch (error) {
    throw error;
  }
};

// Atualizar parâmetro do mapa da fazenda
export const updateFarmMapParameter = async (groupId, farmId, parameterId, parameterData) => {
  try {
    return apiFarms.put(
      `/bovexo/${groupId}/farms/${farmId}/maps/parameters/${parameterId}`,
      parameterData,
      getHeaders(false, null)
    );
  } catch (error) {
    throw error;
  }
};

// Deletar parâmetro do mapa da fazenda
export const deleteFarmMapParameter = async (groupId, farmId, parameterId) => {
  try {
    return apiFarms.delete(
      `/bovexo/${groupId}/farms/${farmId}/maps/parameters/${parameterId}`,
      getHeaders(false, null)
    );
  } catch (error) {
    throw error;
  }
};
